import {SpreadSheetEvent, WorksheetModel} from './../../models/spread-sheet';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { BusyScreen, MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { Subject } from 'rxjs';
import { PlatformCommand, PlatformCommandResponse } from '@shared/commands/command-base';
import { PlatformQueryService } from '@core/services/platform-query.service';
import { take, takeUntil } from 'rxjs/operators';
import { CommandService } from '@core/services/command.service';
import { EventStatus } from '@shared/models/notification-message.model';
import { PlatformToolSpreadsheetHandler } from '@features/spreadsheet/services/platform-tool-spreadsheet-handler';
import { SocketClusterService } from '@core/services/socket-cluster.service';
import { FlexSheetService } from '@features/spreadsheet/services/flex-sheet.service';
import { Configuration } from '@shared/models/configuration';
import { getUserInfo } from '@shared/store/selectors/security.selector';
import { Store } from '@ngrx/store';
import { SecurityState } from '@shared/store/reducers/security.reducer';
import { PlatformQuery } from '@shared/models/platform-query/platform-query';
import { SpreadSheetOpenMode } from '@features/spreadsheet/models/spread-sheet';
import { FlowChartDataService } from '@features/data-survey/services/flow-chart-data.service';
import { ConfigureExcelAsFormService } from '@features/spreadsheet/services/configure-excel-as-form.service';
import { Observable } from 'rxjs';
import { SnackBarService } from '@core/services/snack-bar.service';
import { DialogService } from '@shared/services/dialog-service';
import {
  HideRightSideComponentIconAction,
  PopCurrentRightSideComponentAction,
  SetCurrentRightSideBarFoldOrNotAction,
  SetCurrentRightSideComponentAction,
  ShowHiddenRightSideComponentAction
} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import { PlatformSidebarState } from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import { PlatformSidebarService } from "@shared/components/platform-sidebar/store/platform-sidebar.service";
import { FuseSidebarService } from "@barebone-fuse/@fuse/components/sidebar/sidebar.service";
import { MatTabGroup } from '@angular/material/tabs';
import { RightSideMagicBarStateService } from '@core/services/right-side-magic-bar/right-side-magic-bar-state.service';
import {FlexSheetNavigationService} from "@features/spreadsheet/services/flex-sheet-navigation.service";

class SideNoteConfig {
}

@Component({
    standalone: false,
    selector: 'app-platform-tool-spreadsheet-editor',
  templateUrl: './platform-tool-spreadsheet-editor.component.html',
  styleUrls: ['./platform-tool-spreadsheet-editor.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlatformToolSpreadsheetEditorComponent implements OnInit, OnDestroy, IPlatformToolComponent, AfterViewInit {
  @Input() magicLinkModel: MagicLinkModel;
  @Input() handler: IPlatformToolHandler;
  @Input() selectedTab: TabModel;
  @Input() invalidateSubject: InvalidateSubject = new InvalidateSubject();
  public unsubscribe$ = new Subject<void>();
  isUiReadyForRender = false;
  private workbookSet: any;
  workbooks: any[];
  public currentWorkbook: any;
  worksheets: WorksheetModel[];
  private currentWorksheet: any;
  selectedWorkbookGroupModelsIndex = 0;
  selectedWorkbookIndex = 0;
  private ngUnsubscribe = new Subject<void>();
  isWorkbookSetUpdated = true;
  curUserInfo: any;
  busyScreenModel = new BusyScreen();
  private eventSourceNotification$: Observable<any>;
  workbookGroupModels: any[];
  leftfootNoteOpened = false;
  rightfootNoteOpened = false;
  private sideNoteConfig: SideNoteConfig;
  @ViewChild("tabGroup1", { static: false }) tabGroup1: MatTabGroup;
  @ViewChild("tabGroup2", { static: false }) tabGroup2: MatTabGroup;

  constructor(@Inject(ChangeDetectorRef) private cdRef: ChangeDetectorRef,
    private platformQueryService: PlatformQueryService,
    private commandService: CommandService,
    private platformToolSpreadsheetHandler: PlatformToolSpreadsheetHandler,
    private socketClusterService: SocketClusterService,
    private flowChartDataService: FlowChartDataService,
    private configureExcelAsFormService: ConfigureExcelAsFormService,
    public flexSheetService: FlexSheetService,
    public flexSheetNavigationService: FlexSheetNavigationService,
    private securityStore: Store<SecurityState>,
    private snackBarService: SnackBarService,
    private sidebarService: FuseSidebarService,
    private dialogService: DialogService,
    private rightSideMagicBarStateService: RightSideMagicBarStateService,
    private platformSidebarStore: Store<PlatformSidebarState>
  ) {
    this.busyScreenModel.title = 'Your workbook is loading<br>Please wait...';
    this.busyScreenModel.busyType = 'Busy';
    this.busyScreenModel.message = 'This may take several minutes depending on the workbook calculations.';
    this.flexSheetService.setFlexSheetNavigationService(this.flexSheetNavigationService);// we need to resolve this guu
    this.flexSheetNavigationService.flexSheetService = this.flexSheetService; // we need to resolve this guu
  }
  ngAfterViewInit(): void {
    this.rightSideMagicBarStateService.gridLayoutClass$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      setTimeout(() => {
        if (this.tabGroup1) {
          this.tabGroup1._tabHeader.updatePagination();
          this.tabGroup1.realignInkBar();
        }
        if (this.tabGroup2) {
          this.tabGroup2._tabHeader.updatePagination();
          this.tabGroup2.realignInkBar();
        }
      }, 0);
    });
  }

  ngOnInit(): void {
    if(this.magicLinkModel?.busyScreen?.title) {
      this.busyScreenModel.title = this.magicLinkModel.busyScreen.title;
    }
    if(this.magicLinkModel?.busyScreen?.message) {
      this.busyScreenModel.message = this.magicLinkModel.busyScreen.message;
    }
    this.initiateData();
    this.invalidateSubject.getObservale().pipe(takeUntil(this.unsubscribe$)).subscribe(signature => {
      this.handleInvalidation(signature);
    });
  }


  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return true;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return true;
  }

  onLoad() {
    this.flexSheetService.setMagicLinkModel(this.handler.magicLinkModel ?? this.magicLinkModel);
    this.flexSheetService.spreadSheetOpenMode = SpreadSheetOpenMode.OpenAsWorkbookEditor;
    this.securityStore.select(getUserInfo).pipe(takeUntil(this.ngUnsubscribe)).subscribe((userinfo: any) => {
      this.curUserInfo = userinfo;
    });
    this.flexSheetService.isUiReadyForRender = false;

    this.flexSheetService.setApi(this.selectedTab.tabData['Api']);
    this.flexSheetService.setWorkbookSetId(this.selectedTab.tabData['WorkbookSetId']);
    this.flexSheetService.setPermission(this.selectedTab.tabData['IsReadonly'] === true ? true : false);
    if (this.magicLinkModel.additionalCommands['BeforeExecutionCommand']) {
      this.commandService.executePlatformCommand(this.magicLinkModel.additionalCommands['BeforeExecutionCommand'])
        .pipe(take(1)).subscribe(commandResponse => {
          this.CreateWorkbookSetQuery();
        });
    } else {
      this.CreateWorkbookSetQuery();
    }

    // experimental codes to set worksheet names in change basket command
    this.flexSheetService.spreadSheetEvent$.pipe(takeUntil(this.unsubscribe$)).subscribe(event => {
      if (event.name === SpreadSheetEvent.WorkSheetChanged) {
        const worksheetName = event.payload.name;
        if (this.magicLinkModel && this.magicLinkModel.basketCollection && this.magicLinkModel.basketCollection &&
          this.magicLinkModel.basketCollection.baskets && this.magicLinkModel.basketCollection.baskets.length > 0) {
          for (const basket of this.magicLinkModel.basketCollection.baskets) {
            if (basket.command) {
              basket.command.fieldValues['DefaultWorksheetName'] = worksheetName;
            }
          }
        }
      }
    });
  }

  executeCreateWorkbookSetCommand() {
    this.commandService.executePlatformCommand(this.magicLinkModel.additionalCommands['CreateWorkbookSet'])
      .pipe(take(1)).subscribe(commandResponse => {
        if (commandResponse.status === EventStatus.Success) {
          this.CreateWorkbookSetQuery();
        }
      });
  }


  private CreateWorkbookSetQuery() {
    const query = new PlatformQuery();
    query.name = 'WorkbookSetQuery';
    query.api = this.selectedTab.tabData['Api'];
    query.fieldValues['WorkbookSetId'] = this.selectedTab.tabData['WorkbookSetId'];
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {

      if (!response.fieldValues || !response.fieldValues['WorkbookSetModel'] || !response.fieldValues['WorkbookGroupModels']) {
        this.executeCreateWorkbookSetCommand();
        return;
      }

      this.workbookSet = response.fieldValues['WorkbookSetModel'];
      this.flexSheetService.setWorkbookSet(this.workbookSet);
      this.subscribeCurrentWorkbookSetChannel();
      this.workbookGroupModels = response.fieldValues['WorkbookGroupModels'].sort((x, y) => (x.order - y.order)).filter(x => !x.isHidden).map(o => {
        o.workbookModels = o.workbookModels?.filter(o => !o.isHidden);
        return o;
      });
      this.workbooks = response.fieldValues['WorkbookGroupModels'].sort((x, y) => (x.order - y.order)).filter(x => !x.isHidden).map((o: any) => o.workbookModels).flat(1);
      this.decideSpreadSheetOpenMode('workbooks');

      this.setDefaultWorkbook();
      this.createWorksheetsQuery();
    });
  }

  private setDefaultWorkbook() {
    if (this.magicLinkModel?.tabBar?.tabs[0]?.tabData?.LoadWorkbook) {
      const id = this.magicLinkModel?.tabBar?.tabs[0]?.tabData?.LoadWorkbook;
      this.currentWorkbook = this.workbooks.find(x => x.id === id);
      if (!this.currentWorkbook) {
        this.currentWorkbook = this.workbookGroupModels[this.selectedWorkbookGroupModelsIndex].workbookModels[this.selectedWorkbookIndex];
      } else {
        this.workbookGroupModels.forEach((wbg: any, indexi) => {
          wbg.workbookModels.forEach((wb: any, indexj) => {
            if (wb.id === id) {
              this.selectedWorkbookGroupModelsIndex = indexi;
              this.selectedWorkbookIndex = indexj;
              this.currentWorkbook = this.workbookGroupModels[indexi].workbookModels[indexj];
            }
          });
        });
      }
    } else {
      this.currentWorkbook = this.workbookGroupModels[this.selectedWorkbookGroupModelsIndex].workbookModels[this.selectedWorkbookIndex];
    }
    this.flexSheetService.setCurrentWorkbook(this.currentWorkbook);
    this.platformToolSpreadsheetHandler.setCurrentWorkbook(this.currentWorkbook);
    this.handleGuideModel();
  }

  private subscribeCurrentWorkbookSetChannel() {
    this.socketClusterService.subscribeToChannel(this.workbookSet.id).pipe(takeUntil(this.ngUnsubscribe)).subscribe((notification) => {
      console.log('[Excel] Got Notification workbookSet channel:' + this.workbookSet.id + ' :', notification);
      if (notification && notification.Payload && notification.Payload.LastCommandName === "WorksheetCellEditCommand"
        && ((notification.CreatedBy && this.curUserInfo.email !== notification.CreatedBy.Email))) {
        //this.platformToolSpreadsheetHandler.refreshBreadCrumbBar();
        this.flexSheetService.isWorkbookSetUpdated = true;
        this.platformToolSpreadsheetHandler.flexSheetService.refreshSelectedWorkSheet();
      }

      // The generic staleness signal: the command that finished declared that it changes what this tool is
      // displaying (PlatformCommand.InvalidatesOpenView on the API side). Deliberately not a command name —
      // a name-based test needs a front-end release for every new server-side command — and deliberately
      // not gated on the user: a command dispatched on someone's behalf (from the chat, a job, a workflow)
      // is created BY them while their open grid never saw the change, which is the one case the
      // WorksheetCellEditCommand branch above cannot cover.
      //
      // Ribbon only, no refreshSelectedWorkSheet(): the person may be editing elsewhere in the workbook,
      // and reloading the grid under them would discard that. They reload when they choose.
      // workbookSetLastUpdatedBy is deliberately left unset, so the ribbon reads "This spreadsheet has
      // been updated. Refresh" with no name. Naming CreatedBy would say "updated by <your own name>" for
      // a change you asked the assistant to make, which reads as a mistake rather than an explanation.
      if (notification?.Payload?.InvalidatesView) {
        this.flexSheetService.isWorkbookSetUpdated = true;
        return;
      }

      //We are subscribing with EventSourceId in PlatformtooContainerComponent to update UI like Flow and FileStore.
      if (notification.EventType === 'EventSourceUpdated') {
        return;
      }
      if (notification.EventType === 'LockUnlockNotification') {
        console.log('[Excel] LockUnlock Notification');
        if (notification?.Payload?.IsLocked === true) {
          this.flexSheetService.setPermission(true);
        } else if (notification?.Payload?.IsLocked === false) {
          this.flexSheetService.setPermission(false);
        }
        if (notification?.Payload?.Message) {
          this.snackBarService.showInformation(notification?.Payload?.Message);
        }
        return;
      }
      if (notification.EventType === 'AcknowledgementNotification') {
        this.dialogService.showDialogMessage(notification?.Payload?.Title, notification?.Payload?.Message);
        return;
      }
      if (notification && ((notification.createdBy && this.curUserInfo.email !== notification.createdBy.email) ||
        (this.curUserInfo.email !== notification?.payload?.fieldValues?.EventSourceModel?.modifiedBy?.email))) {
        if (notification.eventType === 'AutoCalculateCommand' || notification.eventType === 'WorkbookSetVisibilityCommand') {
          console.log('[Excel] AutoCalculate Command');
          this.platformToolSpreadsheetHandler.refreshBreadCrumbBar();
          this.platformToolSpreadsheetHandler.flexSheetService.refreshSelectedWorkSheet();
          return;
        }

        this.flexSheetService.workbookSetLastUpdatedBy = notification.CreatedBy;
        this.flexSheetService.onWorksheetChange({ worksheet: this.flexSheetService.getCurrentWorkSheet() });
      }
    });
  }

  createWorksheets() {
    const command = new PlatformCommand('CreateWorksheetsCommand', this.selectedTab.tabData['Api']);
    command.fieldValues['WorkbookId'] = this.currentWorkbook.id;
    command.fieldValues['EventSourceId'] = this.flexSheetService.getCurrentWorkBookSetId();
    command.fieldValues['DestinationTransportId'] = this.flexSheetService.getCurrentWorkBookSetId();
    command.fieldValues['PlatformLinkId'] = this.magicLinkModel.id;
    command.fieldValues['IsReadonly'] = this.selectedTab.tabData['IsReadonly'] ?? false;
    command.setValue('EventSourceApi', command.api);
    command.setValue('IsEventSourceCommand', true);
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
      if(response.fieldValues['ExceptionFound'] == true){
        this.invalidateSubject.invalidate("Refresh");
        return;
      }
      this.createWorksheetsQuery();

    });
  }

  private createWorksheetsQuery() {
    const query = new PlatformQuery(); ``
    query.name = 'WorksheetsQuery';
    query.api = this.selectedTab.tabData['Api'];
    query.fieldValues['WorkbookId'] = this.currentWorkbook.id;
    query.fieldValues['WorkbookSetId'] = this.flexSheetService.getCurrentWorkBookSetId();
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(res => {

      if (!res.fieldValues || !res.fieldValues['WorksheetModels'] || res.fieldValues['WorksheetModels'].length == 0) {
        //if(res.fieldValues['ExceptionFound'] == true)return;
        this.createWorksheets();
        return;
      }
      if(this.magicLinkModel?.tabBar?.tabs[0]?.tabData?.LoadCurrentWorksheetOnly && this.magicLinkModel?.tabBar?.tabs[0]?.tabData?.LoadWorksheet){
        let loadid = this.magicLinkModel?.tabBar?.tabs[0]?.tabData?.LoadWorksheet;
        this.worksheets = res.fieldValues['WorksheetModels'].filter(f => f.id === loadid);
      }
      else if(this.magicLinkModel?.tabBar?.tabs[0]?.tabData?.LoadSelectedWorksheetOnly && this.magicLinkModel?.tabBar?.tabs[0]?.tabData?.LoadWorksheets){
            var loadworksheets = this.magicLinkModel?.tabBar?.tabs[0]?.tabData?.LoadWorksheets as string[];
            var responseWorksheets = res.fieldValues['WorksheetModels'];
            this.worksheets = responseWorksheets.filter(f=>loadworksheets.includes(f.name))
        }
      else{
        this.worksheets = res.fieldValues['WorksheetModels'];
      }
      this.decideSpreadSheetOpenMode('worksheets');
      if (this.worksheets && this.worksheets.length > 0) {

        if (this.magicLinkModel?.tabBar?.tabs[0]?.tabData?.LoadWorksheet) {
          const id = this.magicLinkModel?.tabBar?.tabs[0]?.tabData?.LoadWorksheet;
          this.currentWorksheet = this.worksheets.find(x => x.id === id);
          if (!this.currentWorkbook) {
            this.currentWorksheet = this.worksheets[0];
          }
        } else {
          this.currentWorksheet = this.worksheets[0];
        }
        this.flexSheetService.setWorksheets(this.worksheets);
        this.flexSheetService.isUiReadyForRender = true;
      }
    });
  }

  private decideSpreadSheetOpenMode(onChange: string) {
    const isShowExtractTableCards = this.selectedTab.tabData['ShowExtractTableCards'];
    const extractTableCardWorksheetId = this.selectedTab.tabData['ExtractTableCardWorksheetId'];
    const extractTableCardWorkbookId = this.selectedTab.tabData['ExtractTableCardWorkbookId'];

    if (this.worksheets
      && this.worksheets.length
      && isShowExtractTableCards
      && extractTableCardWorksheetId
      && this.selectedTab.tabData.SpreadSheetOpenMode === SpreadSheetOpenMode.OpenAsQuestionareTable
    ) {
      this.worksheets = this.worksheets.filter(x => x.id === extractTableCardWorksheetId);
      this.flexSheetService.spreadSheetOpenMode = SpreadSheetOpenMode.OpenAsQuestionareTable;
    }
    if (this.workbooks
      && this.workbooks.length
      && isShowExtractTableCards
      && extractTableCardWorkbookId
      && this.selectedTab.tabData.SpreadSheetOpenMode === SpreadSheetOpenMode.OpenAsQuestionareTable
    ) {
      this.workbooks = this.workbooks.filter(x => x.id === extractTableCardWorkbookId);
      this.flexSheetService.spreadSheetOpenMode = SpreadSheetOpenMode.OpenAsQuestionareTable;
    }


    if (onChange === 'workbooks' && this.selectedTab.tabData.SpreadSheetOpenMode === SpreadSheetOpenMode.ConfigureExcelAsFormDesign) {
      this.platformToolSpreadsheetHandler.configureExcelAsFormService = this.configureExcelAsFormService;
      this.flexSheetService.spreadSheetOpenMode = SpreadSheetOpenMode.ConfigureExcelAsFormDesign;
      this.flexSheetService.flexSheetStyleManagementService.magicLinkModel = this.magicLinkModel;
      this.configureExcelAsFormService.selectedTab = this.selectedTab;
      this.configureExcelAsFormService.invalidateSubject = this.invalidateSubject;
      this.configureExcelAsFormService.configureFlowChartService();
    }
  }

  onWorkbookGroupModelsChange(event, isGroup) {
    this.worksheets = null;
    this.flexSheetService.onDestroy();
    if (isGroup) {
      this.selectedWorkbookGroupModelsIndex = event;
      this.selectedWorkbookIndex = 0;
    } else {
      this.selectedWorkbookIndex = event;
    }

    this.currentWorkbook = this.workbookGroupModels[this.selectedWorkbookGroupModelsIndex].workbookModels[this.selectedWorkbookIndex];
    this.flexSheetService.setCurrentWorkbook(this.currentWorkbook);
    this.resetActiveGuideId();
    this.platformToolSpreadsheetHandler.setCurrentWorkbook(this.currentWorkbook);
    this.handleGuideModel();
    this.createWorksheetsQuery();
  }

  private resetActiveGuideId() {
    this.flexSheetService.activeGuideId = '';
  }

  private handleGuideModel() {
    if (!this.leftfootNoteOpened && !this.rightfootNoteOpened) {
      if (this.flexSheetService.getCurrentWorkBook()?.scenarioGuideModel && this.flexSheetService.getCurrentWorkBook()?.scenarioGuideModel?.items.length > 0) {
        this.platformSidebarStore.dispatch(new ShowHiddenRightSideComponentAction('Step-by-Step Process'));
        this.platformSidebarStore.dispatch(
          new SetCurrentRightSideComponentAction({
            component: 'SpreadsheetGuidedTourComponent',
            data: { isUserAction: true },
            componentInfo: { id: 'SpreadsheetGuidedTourComponent' }
          }));
      } else {
        this.platformSidebarStore.dispatch(new PopCurrentRightSideComponentAction(null));
        this.platformSidebarStore.dispatch(new PopCurrentRightSideComponentAction('SpreadsheetGuidedTourComponent'));
        this.platformSidebarStore.dispatch(new HideRightSideComponentIconAction('Step-by-Step Process'));
      }
    }
  }

  unSubscribeCurWorkBookSetChannel() {
    if (this.workbookSet) {
      this.socketClusterService.unsubscribeChannel(this.workbookSet.id);
    }
  }


  ngOnDestroy() {
    this.platformSidebarStore.dispatch(new PopCurrentRightSideComponentAction(null));
    this.platformSidebarStore.dispatch(new PopCurrentRightSideComponentAction('SpreadsheetGuidedTourComponent'));
    this.platformSidebarStore.dispatch(new HideRightSideComponentIconAction('Step-by-Step Process'));
    this.flowChartDataService.destroy();
    this.unSubscribeCurWorkBookSetChannel();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private handleInvalidation(signature: string) {
    if (signature.includes('HardReload') === true) {
      this.onLoad();
    }
  }

  private initiateData() {
    this.flexSheetService.setConfigureExcelAsFormService(this.configureExcelAsFormService);
    this.sideNoteConfig = new SideNoteConfig();
  }

  sideBarToggled(position: string) {
    if (position === 'Left') {
      this.leftfootNoteOpened = !this.leftfootNoteOpened;
      if (this.leftfootNoteOpened) {
        this.closeRightSidebar();
      }
    }
    if (position === 'Right') {
      this.rightfootNoteOpened = !this.rightfootNoteOpened;
      if (this.rightfootNoteOpened) {
        this.closeRightSidebar();
      }
    }
  }
  closeRightSidebar() {
    if (this.sidebarService.getSidebar('rightsidebar')) {
      this.sidebarService.getSidebar('rightsidebar').close();
      this.sidebarService.getSidebar('rightsidebar').fold();
    }
    this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction(null));
    this.platformSidebarStore.dispatch(new SetCurrentRightSideBarFoldOrNotAction(true));
  }
}
